<template>
  <RCard class="invoices">
    <AgGrid ref="agGrid" :options="gridOptions" :row-data="filteredInvoices" @cell-value-changed="cellValueChanged">
      <template #header>
        <Grid gaf="column" align-items="baseline" justify-content="start" gap="var(--r-space-xs)">
          <div class="text-subtitle-1 text-secondary-2 q-ml-sm q-mt-sm">INVOICES</div>
          <q-icon color="tertiary" size="1.1rem" name="fas fa-info-circle">
            <LmTooltip>
              Editing the invoice information here will update it for all subscriptions in the invoice
            </LmTooltip>
          </q-icon>
        </Grid>
      </template>
    </AgGrid>
  </RCard>
</template>

<script>
import * as apiTo from '@/modular-api'
import { gridOptions } from './gridOptions'
// Libraries
import { cloneDeep, get, isEqual } from 'lodash'
// Components
import AgGrid from '@/ag-grid/AgGrid'

export default {
  components: {
    AgGrid
  },

  mixins: [gridOptions],

  props: {
    invoices: Array
  },

  computed: {
    filteredInvoices() {
      if (!this.invoices) return null

      const invoices = this.invoices.filter(i => i.invoice_item)
      return invoices.reduce((acc, curr) => {
        acc.push(curr.invoice_item.vendor_invoice)
        return acc
      }, [])
    }
  },

  created() {
    if (!this.$store.state['subscription-show'].users) {
      this.$store.dispatch('subscription-show/getAndSetUsers')
    }
  },

  methods: {
    getDateFormattedForUpdate(date) {
      const {
        formatDateForPost,
        settings: { date_format }
      } = this
      return formatDateForPost(date, [date_format, 'YYYY-MM-DD'])
    },

    getPayload(field, newValue) {
      if (field.includes('vendor_payment')) {
        const vendorField = field.split('.')[1]
        return {
          vendor_payment: { [vendorField]: newValue }
        }
      } else if (field === 'file' && newValue) {
        const formData = new FormData()
        formData.append('file', newValue)

        return formData
      }
      return { [field]: newValue }
    },

    cellValueChanged({ newValue, column, oldValue, colDef: { field }, data, data: { id } }) {
      const newVal = cloneDeep(newValue) || null
      const oldVal = cloneDeep(oldValue) || null
      if (isEqual(newVal, oldVal)) return

      let newValueForBE = get(data, column.colId)
      const datesFields = ['issue_date', 'due_date', 'vendor_payment.payment_date']
      if (datesFields.includes(field)) {
        newValueForBE = this.getDateFormattedForUpdate(newValueForBE)
      }

      this.updateRow(newValueForBE, field, id)
    },

    updateRow(newValue, field, id) {
      const request = field === 'file' && newValue ? 'UPLOAD_INVOICE_FILE' : 'MODIFY_VENDOR_INVOICE'

      apiTo[request](id, this.getPayload(field, newValue))
        .then(({ data }) => {
          this.$refs.agGrid.updateRow(data.result.id, data.result)
        })
        .catch(() => this.$emit('refresh'))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.invoices {
  @include table-with-no-filters;
}
</style>
